const ClientID = (data) => {
    return {
        type: "Client_ID",
        data: data
    }
}



export { ClientID };